<template>
	<div class="  bg-color--dark--1 h-min-100vh">
		<b-container>
			<b-navbar type="dark" variant="fade">
				<b-navbar-brand href="/" class="align-right">
					<b-img
						left
						src="/assets/logo.png"
						alt="brand-logo"
						width="80px"
						height="80px"
					></b-img>
				</b-navbar-brand>
			</b-navbar>
		</b-container>

		<div class="svg-shape--top w-100 opacity--05">
			<img src="/assets/img/wave-8.svg" alt="wave" class="svg fill--white" />
		</div>
		<!-- end of whole area svg bg -->
		<div class="svg-shape--top opacity--10">
			<img src="/assets/img/wave-9.svg" alt="wave" class="svg fill--white" />
		</div>
		<section class=" align-items-center ">
			<h1 class="text-white mt-0 pt-2   mb-6">
				<center>{{ name }} </center>
			</h1>

			<transition name="fade" enter-active-class="animated fadeIn">
				<b-container class="container-for-background">
					<div class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between" id="normal" v-if="!showUR && !showUL" >
						<b-col
						    sm="12"
							md="5"
							:class="{ red: !disable_ur, m_red: disable_ur }"
							class="my-4"
							@mouseover="(hover_ur = true), (hover_ul = false)"
							@mouseleave="(hover_ur = false), (hover_ul = false)"
						>
						
							<center>
								<b-link class="big red link" :to="{ name: 'supplier' }">
									<h2>
										{{ $t("مشاهده مشتریان") }}
										
									</h2>
								</b-link>
							</center>
						</b-col>
						<b-col
							sm="12"
							md="5"
							:class="{ yellow: !disable_ul, m_yellow: disable_ul }"
							class="my-4 "
							@mouseover="(hover_ul = true), (hover_ur = false)"
							@mouseleave="(hover_ul = false), (hover_ur = false)"
						>
							<center>
								<b-link class="big yellow link" :to="{ name: 'supplierContracts' }">
									<h2>
										{{ $t("مشاهده قراردادها") }}
										
									</h2>
								</b-link>
							</center>
						</b-col>
					</div>

					<div class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between" id="red" v-if="showUR && !showUL" >
						<b-col
						    sm="12"
							md="7"
							class="my-4 red mx-0 mx-lg-2"
							v-show="hover_ur"
							@mouseover="(hover_ur = true), (hover_ul = false)"
							@mouseleave="(hover_ur = false), (hover_ul = false)"
						>
							<center>
								<b-link class="big red link" :to="{ name: 'supplier' }">
									<h2>
										{{ $t("مشاهده مشتریان") }}
										
									</h2>
								</b-link>
							</center>
						</b-col>
						<b-col
						    sm="12"
							md="3"
							:class="{ yellow: !disable_ul, m_yellow: disable_ul }"
							class="my-4 yellow mx-0 mx-lg-2"
							v-show="hover_ur"
						>
							<center>
								<b-link class="big yellow link" :to="{ name: 'supplierContracts' }">
									<h2>
										{{ $t("مشاهده قراردادها") }}
										
									</h2>
								</b-link>
							</center>
						</b-col>
					</div>

					<div class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between" id="yellow" v-if="showUL && !showUR" >
						<b-col
						    sm="12"
							md="3"
							class="my-4 red mx-0 mx-lg-2"
							:class="{ red: !disable_ur, m_red: disable_ur }"
							v-show="hover_ul"
						>
							<center>
								<b-link class="big red link" :to="{ name: 'supplier' }">
									<h2>
										{{ $t("مشاهده مشتریان") }}
										
									</h2>
								</b-link>
							</center>
						</b-col>
						<b-col
						    sm="12"
							md="7"
							class="my-4 yellow mx-0 mx-lg-2"
							v-show="hover_ul"
							@mouseover="(hover_ul = true), (hover_ur = false)"
							@mouseleave="(hover_ul = false), (hover_ur = false)"
						>
							<center>
								<b-link class="big yellow link" :to="{ name: 'supplierContracts' }">
									<h2>
										{{ $t("مشاهده قراردادها") }}
										
									</h2>
								</b-link>
							</center>
						</b-col>
					</div>

					<!-- down row -->
					<div class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between" v-if="!showDR & !showDL" >
						<b-col
							sm="12"
							md="5"
							class="green my-4"
							
							:class="{ green: !disable_dr, m_green: disable_dr }"
							@mouseover="(hover_dr = true), (hover_dl = false)"
							@mouseleave="(hover_dr = false), (hover_dl = false)"
						>
							<center>
								<b-link class="big green link" :to="{ name: 'supplierCustomerSignUp' }">
									<h2>
										{{ $t("ثبت نام متقاضی") }}
										
									</h2>
								</b-link>
							</center>
						</b-col>
						<b-col
							sm="12"
							md="5"
							class="blue my-4"
							:class="{ blue: !disable_dl, m_blue: disable_dl }"
							@mouseover="(hover_dl = true), (hover_dr = false)"
							@mouseleave="(hover_dl = false), (hover_dr = false)"
						>
							<center>
								<div class="big blue link calculator" data-toggle="modal"
								data-target="#calculator">
									<h2>
										{{ $t("supplier.installmentCalculator") }}
										
									</h2>
								</div>
							</center>
						</b-col>
					</div>
					<div class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between" id="green" v-if="showDR" >
						<b-col
						    sm="12"
							md="7"
							class="my-4 green mx-0 mx-lg-2"
							v-show="hover_dr"
							@mouseover="(hover_dr = true), (hover_dl = false)"
							@mouseleave="(hover_dr = false), (hover_dl = false)"
						>
							<center>
								<b-link class="big green link" :to="{ name: 'supplierCustomerSignUp' }">
									<h2>
										{{ $t("ثبت نام متقاضی") }}
										
									</h2>
								</b-link>
							</center>
						</b-col>
						<b-col
						    sm="12"
							md="3"
							:class="{ blue: !disable_dl, m_blue: disable_dl }"
							class="my-4 blue mx-0 mx-lg-2"
							v-show="hover_dr"
						>
							<center>
								<div class="big blue link calculator" data-toggle="modal"
								data-target="#calculator">
									<h2>
										{{ $t("supplier.installmentCalculator") }}
										
									</h2>
								</div>
							</center>
						</b-col>
					</div>

					<div class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between" id="blue" v-if="showDL" >
						<b-col
						    sm="12"
							md="3"
							class="my-4 green mx-0 mx-lg-2"
							:class="{ green: !disable_dr, m_green: disable_dr }"
							v-show="hover_dl"
						>
							<center>
								<b-link class="big green link" :to="{ name: 'supplierCustomerSignUp' }">
									<h2>
										{{ $t("ثبت نام متقاضی") }}
										
									</h2>
								</b-link>
							</center>
						</b-col>
						<b-col
						    sm="12"
							md="7"
							class="my-4 blue mx-0 mx-lg-2"
							v-show="hover_dl"
							@mouseover="(hover_dl = true), (hover_dr = false)"
							@mouseleave="(hover_dl = false), (hover_dr = false)"
						>
							<center>
								<div class="big blue link calculator" data-toggle="modal"
								data-target="#calculator">
									<h2>
										{{ $t("supplier.installmentCalculator") }}
										
									</h2>
								</div>
							</center>
						</b-col>
					</div>
				</b-container>
			</transition>
		</section>
        <!-- ============================================ CALCULATORE ============================= -->
		
            <calculator :title="$t('supplier.installmentCalculator')"></calculator>
        
		<!-- =================================================================================== -->
	</div>
    
</template>

<script>
import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// import VueNumeric from "vue-numeric";
import Calculator from "../../views/Calculator.vue"

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

export default {
	data() {
		return {
			name:"",
			hover: false,
			hover_ur: false,
			hover_ul: false,
			disable_ur: false,
			disable_ul: false,
			showU: true,
			showUR: false,
			showUL: false,

			hover_dl: false,
			hover_dr: false,
			disable_dr: false,
			disable_dl: false,
			showD: true,
			showDR: false,
			showDL: false,
            net_amount: 100000000,
			downpayment: 0.25*100000000,
			number_of_instalment: 12,
			total_amount: 0,
			instalment_amount: 0,
			insalment_cost: 0,
		};
	},
	
	mounted() {
		this.calculatore();
		this.getSupplier()
	},
	computed: {
		isLoggedIn() {
			return this.$store.getters.isSupplierLoggedIn;
		},
		getSupplierName() {
			return this.$store.getters.getSupplierName;
		},
		downpayment_rate(){
			return (this.downpayment/this.net_amount)
		}
	},
    components:
    {
        //VueNumeric,
        Calculator
},
	watch: {
		hover_ur: function() {
			if (!this.disable_ur) {
				if (this.hover_ur) {
					this.showUR = true;
				} else {
					this.showUR = false;
				}
			} else {
				this.showUR = false;
			}
		},
		hover_ul: function() {
			if (!this.disable_ul) {
				if (this.hover_ul) {
					this.showUL = true;
				} else {
					this.showUL = false;
				}
			} else {
				this.showUL = false;
			}
		},

		hover_dr: function() {
			if (!this.disable_dr) {
				if (this.hover_dr) {
					this.showDR = true;
				} else {
					this.showDR = false;
				}
			} else {
				this.showUR = false;
			}
		},
		hover_dl: function() {
			if (!this.disable_dl) {
				if (this.hover_dl) {
					this.showDL = true;
				} else {
					this.showDL = false;
				}
			} else {
				this.showDL = false;
			}
		},
	},
	
	methods: {
		getSupplier()
		{
			this.$store.dispatch("getSupplierInfo").then((res)=>
			{

				this.name = res.body.name
			}).catch((err)=>
			{
				console.log(err)
			})
			
		},
        calculatore() {
			let data = {
				net_amount: this.net_amount,
				number_of_instalment: this.number_of_instalment,
				downpayment_rate: this.downpayment_rate
			};
			this.$store
				.dispatch("supplierCalculator", data)
				.then((resp) => {
					console.log(resp),
						// (this.downpayment = resp.body.downpayment), //پیش پرداخت
						(this.total_amount = resp.body.loan_face_value), //مبلغ تسهیلات
						(this.instalment_amount = resp.body.instalment_amount),
						(this.insalment_cost =
							resp.body.total_amount_of_instalments + this.downpayment);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		
		
	},
};
</script>

<style scoped>
.active {
	background: green;
	height: 40%;
	width: 40%;
}
.red {
	background-color: #ff8800;
	border-radius: 5%;
}
.m_red {
	background-color: rgb(233, 150, 150);
}
.yellow {
	background-color: #fda600;
	border-radius: 5%;
}
.m_yellow {
	background-color: #fbc400;
}
.green {
	background-color: #fbd500;
	border-radius: 5%;
}

.blue {
	background-color: #f9e100;
	border-radius: 5%;
}
.big {
	height: 400px;
}
.container-for-background {
	background-color: rgba(255, 255, 255, 0.733);
	opacity: .85;
	border-radius: 5%;
	border: solid 8px;
	border-color: aliceblue;
}
.link {
	color: black;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-decoration: none;
}
.calculator:hover
{
    cursor: pointer;
}



</style>
<style scoped scr="bootstrap/dist/css/bootstrap.css">

</style>
<style scoped scr="bootstrap-vue/dist/bootstrap-vue.csss"></style>
